export const both = {};
